import { z } from 'zod'
import { SystemMessages } from 'utils/enums/system-message.enum'
import { addCustomIssue } from 'utils/schema.util'
import { isCnj } from 'utils/validate.util'
import { ERROR_MESSAGE_CNJ_INCORRECT } from './error.type'

export enum MeasureStatus {
  CUMPRINDO = 'CUMPRINDO',
  DESCUMPRINDO = 'DESCUMPRINDO',
  EXTINTA = 'EXTINTA',
  OBITO = 'OBITO',
  SUSPENSA = 'SUSPENSA',
  TRANSFERENCIA_CREAS = 'TRANSFERENCIA_CREAS',
  TRANSFERENCIA_COMARCA = 'TRANSFERENCIA_COMARCA',
  SUBSTITUICAO_MEDIDA = 'SUBSTITUICAO_MEDIDA',
  IMPOSSIBILITADO_NOVA_APREENSAO = 'IMPOSSIBILITADO_NOVA_APREENSAO',
  IMPOSSIBILITADO_PRISAO = 'IMPOSSIBILITADO_PRISAO',
}
export enum MeasureStatusLaPsc {
  CUMPRINDO_LA_CUMPRINDO_PSC = 'CUMPRINDO_LA_CUMPRINDO_PSC',
  CUMPRINDO_LA_DESCUMPRINDO_PSC = 'CUMPRINDO_LA_DESCUMPRINDO_PSC',
  DESCUMPRINDO_LA_CUMPRINDO_PSC = 'DESCUMPRINDO_LA_CUMPRINDO_PSC',
  EXTINTA_LA_CUMPRINDO_PSC = 'EXTINTA_LA_CUMPRINDO_PSC',
  EXTINTA_PSC_CUMPRINDO_LA = 'EXTINTA_PSC_CUMPRINDO_LA',
  EXTINTA_LA_PSC = 'EXTINTA_LA_PSC',
  CUMPRINDO_LA_SUSPENSA_PSC = 'CUMPRINDO_LA_SUSPENSA_PSC',
  SUSPENSA_LA_CUMPRINDO_PSC = 'SUSPENSA_LA_CUMPRINDO_PSC',
  SUSPENSA_LA_PSC = 'SUSPENSA_LA_PSC',
  OBITO = 'OBITO',
  TRANSFERENCIA_CREAS = 'TRANSFERENCIA_CREAS',
  TRANSFERENCIA_COMARCA = 'TRANSFERENCIA_COMARCA',
  SUBSTITUICAO_MEDIDA = 'SUBSTITUICAO_MEDIDA',
  IMPOSSIBILITADO_NOVA_APREENSAO = 'IMPOSSIBILITADO_NOVA_APREENSAO',
  IMPOSSIBILITADO_PRISAO = 'IMPOSSIBILITADO_PRISAO',
}

// Subschema para anexos
export const AnexoSchema = z
  .object({
    id: z.number().nullish(),
    arquivoBase64: z.string().nullish(),
    arquivoTipo: z.string().nullish(),
    arquivoNome: z.string().nullish(),

    objetoAnexo: z.string().nullish(),
    tipoArquivo: z.string().nullish(),
    nomeArquivo: z.string().nullish(),
  })
  .nullish()

// Subschema para CREAS
const CreasSchema = z
  .object({
    id: z.number().nullish(),
    nome: z.string().nullish(),
  })
  .nullish()

//Subchema para laPscDTO
const MedidaSocioeducativaLaPscSubSchema = z.object({
  dataInicioDescumprimentoPsc: z.string().nullish(),
  dataInicioDescumprimentoLa: z.string().nullish(),
  dataDesligamentoPorSentencaExtincaoLa: z.string().nullish(),
  dataDesligamentoPorSentencaExtincaoPsc: z.string().nullish(),
  dataDesligamentoPorSentencaExtincaoLaPsc: z.string().nullish(),
  dataSentencaSuspensaoPsc: z.string().nullish(),
  dataSentencaSuspensaoLa: z.string().nullish(),
  dataSentencaSuspensaoLaPsc: z.string().nullish(),
  dataDesligamentoPorSubstituicaoMedida: z.string().nullish(),
  dataDesligamentoPorNovaApreensao: z.string().nullish(),
  dataDesligamentoPorPrisao: z.string().nullish(),
  dataDesligamentoPorObito: z.string().nullish(),
  dataSentencaSuspensao: z.string().nullish(),
  dataTransferenciaCreas: z.string().nullish(),
  dataDesligamentoPorTransferenciaComarca: z.string().nullish(),
  estadoMoradiaDeclarado: z
    .object({
      id: z.number().nullish(),
      nome: z.string().nullish(),
    })
    .nullish(),

  municipioMoradiaDeclarado: z
    .object({
      id: z.number().nullish(),
      nome: z.string().nullish(),
      uf: z
        .object({
          id: z.number().nullish(),
          nome: z.string().nullish(),
        })
        .nullish(),
    })
    .nullish(),

  anexoSinteseObito: AnexoSchema.nullish(),
  anexoCertidaoObito: AnexoSchema.nullish(),
  anexoSinteseMudancaComarca: AnexoSchema.nullish(),
  anexoSinteseNovaApreensao: AnexoSchema.nullish(),
  anexoSinteseTransferenciaCreas: AnexoSchema.nullish(),
  anexoSintesePrisao: AnexoSchema.nullish(),

  creasTransferido: CreasSchema.nullish(),
})

// Subschema para laDTO e pscDTO
const MedidaSocioeducativaSubSchema = z.object({
  dataInicioDescumprimento: z.string().nullish(),
  anexoSinteseDescumprimento: AnexoSchema.nullish(),
  dataDesligamentoPorSentencaExtincao: z.string().nullish(),
  dataDesligamentoPorObito: z.string().nullish(),
  anexoSinteseObito: AnexoSchema.nullish(),
  anexoCertidaoObito: AnexoSchema.nullish(),
  dataSentencaSuspensao: z.string().nullish(),
  creasTransferido: CreasSchema.nullish(),
  dataTransferenciaCreas: z.string().nullish(),
  anexoSinteseTransferenciaCreas: AnexoSchema.nullish(),
  dataDesligamentoPorTransferenciaComarca: z.string().nullish(),
  estadoMoradiaDeclarado: z
    .object({
      id: z.number().nullish(),
      nome: z.string().nullish(),
    })
    .nullish(),

  municipioMoradiaDeclarado: z
    .object({
      id: z.number().nullish(),
      nome: z.string().nullish(),
      uf: z
        .object({
          id: z.number().nullish(),
          nome: z.string().nullish(),
        })
        .nullish(),
    })
    .nullish(),

  anexoSinteseMudancaComarca: AnexoSchema.nullish(),
  dataDesligamentoPorSubstituicaoMedida: z.string().nullish(),
  dataDesligamentoPorNovaApreensao: z.string().nullish(),
  anexoSinteseNovaApreensao: AnexoSchema.nullish(),
  dataDesligamentoPorPrisao: z.string().nullish(),
  anexoSintesePrisao: AnexoSchema.nullish(),
})

// Schema principal
export const SocioeducationMeasureProceduralDataSchema = z
  .object({
    id: z.number().nullish(),
    processoVij: z.string().nullish(),
    processoVemse: z.string().nullish(),
    medidaSocioeducativa: z.object({
      statusMedida: z.string().nullish(),
      statusMedidaLaPsc: z.string().nullish(),
      la: MedidaSocioeducativaSubSchema.nullish(),
      psc: MedidaSocioeducativaSubSchema.nullish(),
      laPsc: MedidaSocioeducativaLaPscSubSchema.nullish(),
    }),
    remissao: z
      .object({
        trataRemissao: z.boolean().nullish(),
        tipoRemissao: z.string().nullish(),
      })
      .nullish(),
    tipoMedidaSocioeducativa: z.string().nullish(),
    medidaRestritiva: z.string().nullish(),
    reinfracao: z.boolean().nullish(),
  })

  .superRefine((fields, ctx) => {
    const addIssue = (field: string, message: string) => addCustomIssue(ctx, [field], message)

    if (fields.processoVij && fields.processoVij.length > 0 && !isCnj(fields.processoVij)) {
      addIssue('processoVij', ERROR_MESSAGE_CNJ_INCORRECT)
    }

    if (fields.processoVemse && fields.processoVemse.length > 0 && !isCnj(fields.processoVemse)) {
      addIssue('processoVemse', ERROR_MESSAGE_CNJ_INCORRECT)
    }

    if (!fields.processoVij && !fields.processoVemse) {
      addIssue('processoVij', SystemMessages.MESSAGE_032)
      addIssue('processoVemse', SystemMessages.MESSAGE_032)
    }

    if (
      fields.remissao?.trataRemissao &&
      (fields.remissao.tipoRemissao === null || fields.remissao.tipoRemissao === undefined)
    ) {
      addIssue('remissao.tipoRemissao', SystemMessages.MESSAGE_002)
    }

    if (fields.tipoMedidaSocioeducativa === null || fields.tipoMedidaSocioeducativa === undefined) {
      addIssue('tipoMedidaSocioeducativa', SystemMessages.MESSAGE_002)
    }

    if (fields.medidaRestritiva === null || fields.medidaRestritiva === undefined) {
      addIssue('medidaRestritiva', SystemMessages.MESSAGE_002)
    }

    if (fields.reinfracao === null || fields.reinfracao === undefined) {
      addIssue('reinfracao', SystemMessages.MESSAGE_002)
    }

    if (
      (fields.tipoMedidaSocioeducativa === 'LA' || fields.tipoMedidaSocioeducativa === 'PSC') &&
      (fields.medidaSocioeducativa.statusMedida === null ||
        fields.medidaSocioeducativa.statusMedida === undefined)
    ) {
      addIssue('medidaSocioeducativa.statusMedida', SystemMessages.MESSAGE_002)
    }

    if (
      fields.tipoMedidaSocioeducativa === 'LA_PSC' &&
      (fields.medidaSocioeducativa.statusMedidaLaPsc === null ||
        fields.medidaSocioeducativa.statusMedidaLaPsc === undefined)
    ) {
      addIssue('medidaSocioeducativa.statusMedidaLaPsc', SystemMessages.MESSAGE_002)
    }

    //LA_PSC
    if (
      fields.tipoMedidaSocioeducativa === 'LA_PSC' &&
      fields.medidaSocioeducativa.statusMedidaLaPsc === 'TRANSFERENCIA_COMARCA'
    ) {
      if (
        fields.medidaSocioeducativa?.laPsc?.estadoMoradiaDeclarado?.id === null ||
        fields.medidaSocioeducativa?.laPsc?.estadoMoradiaDeclarado?.id === 0
      ) {
        addIssue(`medidaSocioeducativa.laPsc.estadoMoradiaDeclarado.id`, SystemMessages.MESSAGE_002)
      }

      if (
        fields.medidaSocioeducativa?.laPsc?.estadoMoradiaDeclarado?.id === 0 &&
        fields.medidaSocioeducativa?.laPsc?.estadoMoradiaDeclarado?.id === null &&
        (fields.medidaSocioeducativa?.laPsc?.municipioMoradiaDeclarado?.id === 0 ||
          fields.medidaSocioeducativa?.laPsc?.municipioMoradiaDeclarado?.id === null)
      ) {
        addIssue(
          `medidaSocioeducativa.laPsc.municipioMoradiaDeclarado.id`,
          SystemMessages.MESSAGE_002,
        )
      }
    }

    //LA
    if (
      fields.tipoMedidaSocioeducativa === 'LA' &&
      fields.medidaSocioeducativa.statusMedida === 'TRANSFERENCIA_COMARCA'
    ) {
      if (
        fields.medidaSocioeducativa?.la?.estadoMoradiaDeclarado?.id === null ||
        fields.medidaSocioeducativa?.la?.estadoMoradiaDeclarado?.id === 0
      ) {
        addIssue(`medidaSocioeducativa.la.estadoMoradiaDeclarado.id`, SystemMessages.MESSAGE_002)
      }

      if (
        fields.medidaSocioeducativa?.la?.estadoMoradiaDeclarado?.id !== 0 &&
        fields.medidaSocioeducativa?.la?.estadoMoradiaDeclarado?.id !== null &&
        (fields.medidaSocioeducativa?.la?.municipioMoradiaDeclarado?.id === 0 ||
          fields.medidaSocioeducativa?.la?.municipioMoradiaDeclarado?.id === null)
      ) {
        addIssue(`medidaSocioeducativa.la.municipioMoradiaDeclarado.id`, SystemMessages.MESSAGE_002)
      }
    }

    //PSC
    if (
      fields.tipoMedidaSocioeducativa === 'PSC' &&
      fields.medidaSocioeducativa.statusMedida === 'TRANSFERENCIA_COMARCA'
    ) {
      if (
        fields.medidaSocioeducativa?.psc?.estadoMoradiaDeclarado?.id === null ||
        fields.medidaSocioeducativa?.psc?.estadoMoradiaDeclarado?.id === 0
      ) {
        addIssue(`medidaSocioeducativa.psc.estadoMoradiaDeclarado.id`, SystemMessages.MESSAGE_002)
      }

      if (
        fields.medidaSocioeducativa?.psc?.estadoMoradiaDeclarado?.id !== 0 &&
        fields.medidaSocioeducativa?.psc?.estadoMoradiaDeclarado?.id !== null &&
        (fields.medidaSocioeducativa?.psc?.municipioMoradiaDeclarado?.id === 0 ||
          fields.medidaSocioeducativa?.psc?.municipioMoradiaDeclarado?.id === null)
      ) {
        addIssue(
          `medidaSocioeducativa.psc.municipioMoradiaDeclarado.id`,
          SystemMessages.MESSAGE_002,
        )
      }
    }

    const statusTipoMap = {
      DESCUMPRINDO: {
        LA: 'la.dataInicioDescumprimento',
        PSC: 'psc.dataInicioDescumprimento',
      },
      EXTINTA: {
        LA: 'la.dataDesligamentoPorSentencaExtincao',
        PSC: 'psc.dataDesligamentoPorSentencaExtincao',
      },
      OBITO: {
        LA: 'la.dataDesligamentoPorObito',
        PSC: 'psc.dataDesligamentoPorObito',
      },
      SUSPENSA: {
        LA: 'la.dataSentencaSuspensao',
        PSC: 'psc.dataSentencaSuspensao',
      },
      TRANSFERENCIA_CREAS: {
        LA: 'la.dataTransferenciaCreas',
        PSC: 'psc.dataTransferenciaCreas',
      },
      TRANSFERENCIA_COMARCA: {
        LA: 'la.dataDesligamentoPorTransferenciaComarca',
        PSC: 'psc.dataDesligamentoPorTransferenciaComarca',
      },
      SUBSTITUICAO_MEDIDA: {
        LA: 'la.dataDesligamentoPorSubstituicaoMedida',
        PSC: 'psc.dataDesligamentoPorSubstituicaoMedida',
      },
      IMPOSSIBILITADO_NOVA_APREENSAO: {
        LA: 'la.dataDesligamentoPorNovaApreensao',
        PSC: 'psc.dataDesligamentoPorNovaApreensao',
      },
      IMPOSSIBILITADO_PRISAO: {
        LA: 'la.dataDesligamentoPorPrisao',
        PSC: 'psc.dataDesligamentoPorPrisao',
      },
    } as const

    const statusTipoLaPscMap = {
      CUMPRINDO_LA_DESCUMPRINDO_PSC: {
        LA_PSC: 'laPsc.dataInicioDescumprimentoPsc',
      },
      DESCUMPRINDO_LA_CUMPRINDO_PSC: {
        LA_PSC: 'laPsc.dataInicioDescumprimentoLa',
      },
      EXTINTA_LA_CUMPRINDO_PSC: {
        LA_PSC: 'laPsc.dataDesligamentoPorSentencaExtincaoLa',
      },
      EXTINTA_PSC_CUMPRINDO_LA: {
        LA_PSC: 'laPsc.dataDesligamentoPorSentencaExtincaoPsc',
      },
      EXTINTA_LA_PSC: {
        LA_PSC: 'laPsc.dataDesligamentoPorSentencaExtincaoLaPsc',
      },
      CUMPRINDO_LA_SUSPENSA_PSC: {
        LA_PSC: 'laPsc.dataSentencaSuspensaoPsc',
      },
      SUSPENSA_LA_CUMPRINDO_PSC: {
        LA_PSC: 'laPsc.dataSentencaSuspensaoLa',
      },
      SUSPENSA_LA_PSC: {
        LA_PSC: 'laPsc.dataSentencaSuspensaoLaPsc',
      },
      OBITO: {
        LA_PSC: 'laPsc.dataDesligamentoPorObito',
      },
      TRANSFERENCIA_CREAS: {
        LA_PSC: 'laPsc.dataTransferenciaCreas',
      },
      TRANSFERENCIA_COMARCA: {
        LA_PSC: 'laPsc.dataDesligamentoPorTransferenciaComarca',
      },
      SUBSTITUICAO_MEDIDA: {
        LA_PSC: 'laPsc.dataDesligamentoPorSubstituicaoMedida',
      },
      IMPOSSIBILITADO_NOVA_APREENSAO: {
        LA_PSC: 'laPsc.dataDesligamentoPorNovaApreensao',
      },
      IMPOSSIBILITADO_PRISAO: {
        LA_PSC: 'laPsc.dataDesligamentoPorPrisao',
      },
    } as const

    type StatusMedida = keyof typeof statusTipoMap
    type TipoMedida = keyof typeof statusTipoMap[StatusMedida]

    type StatusMedidaLaPsc = keyof typeof statusTipoLaPscMap
    type TipoMedidaLaPsc = keyof typeof statusTipoLaPscMap[StatusMedidaLaPsc]

    const statusMedida = fields.medidaSocioeducativa.statusMedida as StatusMedida
    const tipoMedida = fields.tipoMedidaSocioeducativa as TipoMedida

    const statusMedidaLaPsc = fields.medidaSocioeducativa.statusMedidaLaPsc as StatusMedidaLaPsc
    const tipoMedidaLaPsc = fields.tipoMedidaSocioeducativa as TipoMedidaLaPsc

    if (
      statusTipoMap[statusMedida]?.[tipoMedida] ||
      statusTipoLaPscMap[statusMedidaLaPsc]?.[tipoMedidaLaPsc]
    ) {
      const fieldPath =
        fields.tipoMedidaSocioeducativa === 'LA_PSC'
          ? statusTipoLaPscMap[statusMedidaLaPsc][tipoMedidaLaPsc]
          : statusTipoMap[statusMedida][tipoMedida]
      const fieldValue = fieldPath.split('.').reduce((obj, key) => {
        if (obj && typeof obj === 'object') {
          return (obj as Record<string, any>)[key]
        }
        return undefined
      }, fields.medidaSocioeducativa)

      if (fieldValue === null || fieldValue === undefined) {
        addIssue(`medidaSocioeducativa.${fieldPath}`, SystemMessages.MESSAGE_002)
      }
    }
    const anexoTipoMap = {
      DESCUMPRINDO: {
        LA: 'la.anexoSinteseDescumprimento.arquivoBase64',
        PSC: 'psc.anexoSinteseDescumprimento.arquivoBase64',
      },
      OBITO: {
        LA: 'la.anexoSinteseObito.arquivoBase64',
        PSC: 'psc.anexoSinteseObito.arquivoBase64',
      },
      TRANSFERENCIA_CREAS: {
        LA: 'la.anexoSinteseTransferenciaCreas.arquivoBase64',
        PSC: 'psc.anexoSinteseTransferenciaCreas.arquivoBase64',
      },
      TRANSFERENCIA_COMARCA: {
        LA: 'la.anexoSinteseMudancaComarca.arquivoBase64',
        PSC: 'psc.anexoSinteseMudancaComarca.arquivoBase64',
      },
      IMPOSSIBILITADO_NOVA_APREENSAO: {
        LA: 'la.anexoSinteseNovaApreensao.arquivoBase64',
        PSC: 'psc.anexoSinteseNovaApreensao.arquivoBase64',
      },
      IMPOSSIBILITADO_PRISAO: {
        LA: 'la.anexoSintesePrisao.arquivoBase64',
        PSC: 'psc.anexoSintesePrisao.arquivoBase64',
      },
    } as const

    const anexoTipoLaPscMap = {
      DESCUMPRINDO_LA_CUMPRINDO_PSC: {
        LA_PSC: 'laPsc.anexoSinteseDescumprimento.arquivoBase64.arquivoBase64',
      },
      OBITO: {
        LA_PSC: 'laPsc.anexoSinteseObito.arquivoBase64',
      },
      TRANSFERENCIA_CREAS: {
        LA_PSC: 'laPsc.anexoSinteseTransferenciaCreas.arquivoBase64',
      },
      TRANSFERENCIA_COMARCA: {
        LA_PSC: 'laPsc.anexoSinteseMudancaComarca.arquivoBase64',
      },
      IMPOSSIBILITADO_NOVA_APREENSAO: {
        LA_PSC: 'laPsc.anexoSinteseNovaApreensao.arquivoBase64',
      },
      IMPOSSIBILITADO_PRISAO: {
        LA_PSC: 'laPsc.anexoSintesePrisao.arquivoBase64',
      },
    } as const

    type AnexoStatusMedida = keyof typeof anexoTipoMap
    type AnexoTipoMedida = keyof typeof anexoTipoMap[AnexoStatusMedida]

    type AnexoStatusMedidaLaPsc = keyof typeof anexoTipoLaPscMap
    type AnexoTipoMedidaLaPsc = keyof typeof anexoTipoLaPscMap[AnexoStatusMedidaLaPsc]

    const anexoStatusMedida = fields.medidaSocioeducativa.statusMedida as AnexoStatusMedida
    const anexoTipoMedida = fields.tipoMedidaSocioeducativa as AnexoTipoMedida

    const anexoStatusMedidaLaPsc = fields.medidaSocioeducativa
      .statusMedidaLaPsc as AnexoStatusMedidaLaPsc
    const anexoTipoMedidaLaPsc = fields.tipoMedidaSocioeducativa as AnexoTipoMedidaLaPsc

    if (
      anexoTipoMap[anexoStatusMedida]?.[anexoTipoMedida] ||
      anexoTipoLaPscMap[anexoStatusMedidaLaPsc]?.[anexoTipoMedidaLaPsc]
    ) {
      const anexoFieldPath =
        fields.tipoMedidaSocioeducativa === 'LA_PSC'
          ? anexoTipoLaPscMap[anexoStatusMedidaLaPsc][anexoTipoMedidaLaPsc]
          : anexoTipoMap[anexoStatusMedida][anexoTipoMedida]

      const anexoFieldValue = anexoFieldPath.split('.').reduce((obj, key) => {
        if (obj && typeof obj === 'object') {
          return (obj as Record<string, any>)[key]
        }
        return undefined
      }, fields.medidaSocioeducativa)

      if (anexoFieldValue === null || anexoFieldValue === undefined) {
        addIssue(`medidaSocioeducativa.${anexoFieldPath}`, SystemMessages.MESSAGE_002)
      }

      if (
        (fields.tipoMedidaSocioeducativa === 'LA' || fields.tipoMedidaSocioeducativa === 'PSC') &&
        fields.medidaSocioeducativa.statusMedidaLaPsc === 'OBITO'
      ) {
        const certidaoObitoFieldPath =
          fields.tipoMedidaSocioeducativa === 'LA'
            ? 'la.anexoCertidaoObito.arquivoBase64'
            : fields.tipoMedidaSocioeducativa === 'PSC'
            ? 'psc.anexoCertidaoObito.arquivoBase64'
            : ''
        const certidaoObitoFieldValue = certidaoObitoFieldPath.split('.').reduce((obj, key) => {
          if (obj && typeof obj === 'object') {
            return (obj as Record<string, any>)[key]
          }
          return undefined
        }, fields.medidaSocioeducativa)
        if (certidaoObitoFieldValue === null || certidaoObitoFieldValue === undefined) {
          addIssue(`medidaSocioeducativa.${certidaoObitoFieldPath}`, SystemMessages.MESSAGE_002)
        }
      }

      if (fields.tipoMedidaSocioeducativa === 'LA_PSC') {
        const certidaoObitoFieldPath = 'laPsc.anexoCertidaoObito.arquivoBase64'

        const certidaoObitoFieldValue = certidaoObitoFieldPath.split('.').reduce((obj, key) => {
          if (obj && typeof obj === 'object') {
            return (obj as Record<string, any>)[key]
          }
          return undefined
        }, fields.medidaSocioeducativa)

        if (certidaoObitoFieldValue === null || certidaoObitoFieldValue === undefined) {
          addIssue(`medidaSocioeducativa.${certidaoObitoFieldPath}`, SystemMessages.MESSAGE_002)
        }
      }
    }
  })

export type SocioeducationMeasureProceduralDataType = z.infer<
  typeof SocioeducationMeasureProceduralDataSchema
>

export type MedidaSocioeducativaSubSchemaType = z.infer<typeof MedidaSocioeducativaSubSchema>

export const MedidaSocioeducativaSubSchemaInit: MedidaSocioeducativaSubSchemaType = {
  estadoMoradiaDeclarado: {
    id: 0,
    nome: '',
  },
  municipioMoradiaDeclarado: {
    id: 0,
    nome: '',
    uf: {
      id: 0,
      nome: '',
    },
  },
}
// Crie um esquema de inicialização específico para laPscDTO
export const MedidaSocioeducativaLaPscSubSchemaInit: z.infer<
  typeof MedidaSocioeducativaLaPscSubSchema
> = {
  estadoMoradiaDeclarado: {
    id: null,
    nome: '',
  },
  municipioMoradiaDeclarado: {
    id: null,
    nome: '',
    uf: {
      id: 0, // Use 0 em vez de null para atender ao requisito de não ser null/undefined
      nome: '',
    },
  },
  // Adicione outras propriedades necessárias
}

// E então use-o para inicializar:
export const SocioeducationMeasureProceduralDataDefaultValues: SocioeducationMeasureProceduralDataType =
  {
    medidaRestritiva: '',
    processoVij: '',
    processoVemse: '',
    medidaSocioeducativa: {
      la: MedidaSocioeducativaSubSchemaInit,
      psc: MedidaSocioeducativaSubSchemaInit,
      laPsc: MedidaSocioeducativaLaPscSubSchemaInit, // Use o esquema específico
    },
  }
